export default __webpack_public_path__ + "static/media/kitchen_audios.cc59bbbe.ogg";